export const idXboxName = "ID@Xbox";
export const idAzureName = "ID@Azure";
export const pitchName = "Pitch";

export type ProgramColumnConfig = {
  title: string;
  content: string;
  doubleSizedColumn?: boolean;
};
